// Maps the trimmed wizard form to the createGameWithAI payload. The redesigned
// wizard drops Question Style, Host Personality and the category chips, so we
// send sensible defaults and fold the "tell us about your group" text into theme.

export const AI_DEFAULT_TONE = "Normal";
export const AI_DEFAULT_HOST = "Friendly";

const DIFFICULTY_VALUE = { easy: "Easy", medium: "Medium", hard: "Hard" };

export const mapDifficulty = (difficulty) => DIFFICULTY_VALUE[difficulty] || "Medium";

export const buildThemeWithGroup = (theme, difficulty, difficultyOther) => {
  const extra = difficulty === "other" && difficultyOther && difficultyOther.trim()
    ? `\n\nAbout the group: ${difficultyOther.trim()}`
    : "";
  return `${theme || ""}${extra}`;
};
